import React, { useState, useEffect, useRef } from 'react';
import './Campanha.css';
import campanhaImage from './images/atendimento-familia.jpg';

const CampanhaOQueFazemos = () => {
  // Estado para controlar se o componente está visível
  const [isVisible, setIsVisible] = useState(false);
  // Referência para o elemento que queremos observar
  const imageRef = useRef(null);

  useEffect(() => {
    // Crie uma instância do IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        // entries é um array de objetos, um para cada elemento observado
        // Pegamos o primeiro (e único)
        const entry = entries[0];
        // Atualizamos o estado baseado na propriedade isIntersecting
        setIsVisible(entry.isIntersecting);
      },
      {
        // A opacidade '0' indica que o callback será executado
        // assim que o elemento começar a aparecer/desaparecer
        threshold: 0.1,
      }
    );

    // Verifique se a referência existe antes de observar
    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    // Função de limpeza
    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []); // O array vazio garante que o observer seja criado apenas uma vez

  return (
    <div className="campaign-container" ref={imageRef}>
      <div className="campaign-content3">
        {/* Lado Esquerdo: Texto e Botão */}
        <div className="campaign-text-section">
          <h2 className="campaign-title">Você sonha, a gente realiza</h2>
          <p className="campaign-description">
            Projetamos, produzimos, montamos e integramos móveis, espaços e ambientes sob medida, em projetos personalizados.
            Colocamos atenção e cuidado em cada detalhe, ajudando você ou sua empresa a realizar sonhos e concretizar planos.
            Nosso compromisso é materializar suas idéias, garantindo que cada espaço de seu projeto reflita a felicidade e
            a história de quem vive nele.  
          </p>
        </div>

        {/* Lado Direito: Imagem */}
        <div className="campaign-image-section">
          <img
            src={campanhaImage}
            alt="Joias de Luxo e Design Extraordinário"
            // Aplica a classe condicionalmente
            className={`campaign-image ${isVisible ? 'zoomed-in' : ''}`}
          />
        </div>
      </div>
    </div>
  );
};

export default CampanhaOQueFazemos;